import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '@/store';
import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

//import './index.scss';

type OverUnderProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const OverUnder = (componentProps: OverUnderProps) => {
  let props = componentProps;
  let isVisible = true;

  const dataElementContext = React.useContext(DataElementContext);
  [props, isVisible] = processComponentProps(props, dataElementContext);
  const [state, setState] = React.useState({
    types: [
      { label: 'Main', value: 'main' },
      { label: 'All', value: 'all' },
    ],
    selectedType: 'main',
  });

  const onSetType = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    const tab = event.currentTarget.getAttribute('data-tab');
    if (['main', 'all'].includes(tab || '')) {
      setState((prevState) => ({
        ...prevState,
        selectedType: tab || '',
      }));
    }
    event.stopPropagation();
  }, []);

  const mainHeader = React.useCallback(
    (market: any) => {
      if (!market) return [];
      const columns: any[] = [];
      const columnsName: any = {};

      market.outcomes?.forEach((outcome: any) => {
        const value = (outcome.nameWithoutArgument?.[2] ?? outcome.nameWithoutArgument?.[0] ?? '').toLowerCase();
        if (value && !columnsName[value]) {
          columns.push({
            label: outcome.nameWithoutArgument,
            value: value,
          });
          columnsName[value] = true;
        }
      });

      const sortBy = (props.properties.sortBy ?? []).reduce((acc: any, curr: any, index: number) => {
        acc[curr] = index;
        return acc;
      }, {});

      columns.sort((a, b) => {
        if (sortBy[a.value] != null && sortBy[b.value] != null) return sortBy[a.value] - sortBy[b.value];
        return 0;
      });

      // insert empty column at the beginning
      columns.unshift({ label: '', value: 'empty' });

      return columns;
    },
    [props.properties.sortBy],
  );
  const mainOutcomes = React.useCallback(
    (market: any) => {
      if (!market) return [];
      const outcomesMap: any = {};

      market.outcomes?.forEach((outcome: any) => {
        if (outcome.argument == null) return;

        const argumentKey = outcome.argument?.toString();
        if (!outcomesMap[argumentKey]) {
          outcomesMap[argumentKey] = [];
        }

        outcomesMap[argumentKey].push(outcome);
      });

      const outcomesList: any[] = [];

      const sortBy = (props.properties.sortBy ?? []).reduce((acc: any, curr: any, index: number) => {
        acc[curr] = index;
        return acc;
      }, {});

      Object.keys(outcomesMap)
        .sort((a: any, b: any) => parseFloat(a) - parseFloat(b))
        .forEach((argumentKey: any) => {
          outcomesMap[argumentKey].sort((a: any, b: any) => {
            if (sortBy[a.mboDisplayName] && sortBy[b.mboDisplayName])
              return sortBy[a.mboDisplayName] - sortBy[b.mboDisplayName];
            return 0;
          });

          if (outcomesMap[argumentKey].length === 1) {
            if (outcomesMap[argumentKey][0].nameWithoutArgument?.['2'] === 'Under') {
              outcomesMap[argumentKey].unshift({ isEmpty: true });
            } else {
              outcomesMap[argumentKey].push({ isEmpty: true });
            }
          }

          outcomesList.push({ outcomes: [{ label: argumentKey }, ...outcomesMap[argumentKey]] });
        });

      return outcomesList;
    },
    [props.properties.sortBy],
  );

  const contextValue = React.useMemo(() => {
    const market = props.properties.market;

    return {
      market,
      mainHeader: mainHeader(market),
      mainOutcomes: mainOutcomes(market),
      actions: {
        onSetType,
      },
      ...state,
    };
  }, [props, state, mainHeader, mainOutcomes, onSetType]);

  if (!isVisible) return null;
  //console.log('OverUnder[contextValue]', contextValue);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default OverUnder;
